import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useSelector } from '@bonanza-social/toolkit/state';
import { PressableIcon } from '@bonanza-social/moonlight';
import { selectGame } from '../../../../state';
import { InfoProps } from './Info.types';

function Info({ gameId }: InfoProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const { name } = useSelector(selectGame(gameId)) || {};

  const onPress = useCallback(() => {
    navigation.navigate('GameInfoScreen', { name });
  }, [name, navigation]);

  return (
    <PressableIcon
      name="info"
      position="absolute"
      right="space-100"
      bottom="space-050"
      borderRadius="radius-400"
      backgroundColor="backdropPrimary"
      color="darkSurfacePrimary"
      iconWidth="space-500"
      iconHeight="space-500"
      padding="space-100"
      onPress={onPress}
    />
  );
}

export default memo(Info);
